<template>
  <div class="cooperate">
    <h2>合作伙伴</h2>
    <el-tabs>
      <el-tab-pane>
        <span slot="label">
          合作厂家
          <i class="m-circle-dot"></i>
        </span>
        <div class="content content-icons">
          <!-- <div class="content content_first"> -->
          <div class="icons icons-one">
            <a href="http://www.dfcv.com.cn/Index.aspx" target="_blank">
              <img alt src="@image/dfsyc.png" style="width:153px;height:36px" />
            </a>

            <a href="http://www.cnhtcpurch.com/" target="_blank">
              <img alt src="@image/zgzq.png" style="width:155px;height:41px" />
            </a>
            <a href="http://www.sxqc.com/index_zqpc.aspx" target="_blank">
              <img alt src="@image/sqjt.png" style="width:159px;height:40px" />
            </a>
            <a href="https://www.aumantruck.com/" target="_blank">
              <img alt src="@image/fdml.png" style="width:146px;height:42px" />
            </a>
            <a href="http://www.hongyantruck.com/" target="_blank">
              <img alt src="@image/sqywk.png" style="width:186px;height:34px" />
            </a>
            <a href="https://www.jac.com.cn/" target="_blank">
              <img alt src="@image/jhqc.png" style="width:70px;height:40px" />
            </a>
          </div>
          <div class="icons" style="magin-left:50px">
            <a href="https://www.xcmg.com/xgqc/" target="_blank">
              <img
                alt
                src="@image/xgqc.png"
                style="width:100px;height:45px;margin-left:35px"
              />
            </a>
            <a href="http://www.camc.cc/" target="_blank">
              <img
                alt
                src="@image/hlxm.png"
                style="width:156px;height:32px;margin-left:30px"
              />
            </a>
            <a href="http://www.ctruck.com.cn/" target="_blank">
              <img alt src="@image/lhkc.png" style="width:131px;height:38px" />
            </a>
            <a href="http://www.beiben.cn/" target="_blank">
              <img alt src="@image/bbzk.png" style="width:148px;height:40px" />
            </a>
            <a href="http://www.jmch.com.cn/" target="_blank">
              <img
                alt
                src="@image/jlqc.png"
                style="width:137px;height:36px;margin-left:20px"
              />
            </a>
            <a href="https://www.sanygroup.com/" target="_blank">
              <img
                alt
                src="@image/syjt.png"
                style="width:98px;height:29px;margin-left:20px"
              />
            </a>
          </div>
          <div class="icons-thr">
            <a href="https://www.lingyu.com/" target="_blank">
              <img
                alt
                src="@image/lyqc.png"
                style="width:136px;height:39px;,margin-left:35px"
              />
            </a>
            <a href="http://www.tanghongzhonggong.cn/#page1" target="_blank">
              <img
                alt
                src="@image/thzg.png"
                style="width:106px;height:71px;margin-top:-3px;margin-left:60px"
              />
            </a>
            <a href="http://www.yateauto.com/" target="_blank">
              <img
                alt
                src="@image/ytzg.png"
                style="width:158px;height:30px;margin-left:45px"
              />
            </a>
            <a href="http://www.cimc-whrj.com/" target="_blank">
              <img
                alt
                src="@image/rjqc.png"
                style="width:206px;height:49px;margin-top:10px"
              />
            </a>
            <img alt src="@image/ftls.png" style="width:206px;height:29px;" />
          </div>
        </div>
        <div @click="headerMore" class="bottom">
          <i class="el-icon-arrow-left"></i>
          <p>查看更多伙伴</p>
          <i class="el-icon-arrow-right"></i>
        </div>
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label">
          合作银行
          <i class="m-circle-dot"></i>
        </span>
        <div class="content content_sec">
          <a href="http://bank.pingan.com/" target="_blank">
            <img alt src="@image/pabank.png" />
          </a>
          <!-- <img src="@image/cnbank.png" alt="" /> -->
        </div>
        <div @click="headerMore" class="bottom">
          <i class="el-icon-arrow-left"></i>
          <p>查看更多伙伴</p>
          <i class="el-icon-arrow-right"></i>
        </div>
      </el-tab-pane>
      <el-tab-pane>
        <span slot="label">合作经销商</span>
        <div class="content content_thr">
          <div :key="index" v-for="(item, index) in saleData">{{ item }}</div>
        </div>
        <div @click="headerMore" class="bottom">
          <i class="el-icon-arrow-left"></i>
          <p>查看更多伙伴</p>
          <i class="el-icon-arrow-right"></i>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// import Qs from 'qs'
import { getSale } from '@/api/sale'
export default {
  name: 'Cooperate',
  data() {
    return {
      activeName: 'first',
      saleData: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    //经销商
    init() {
      const data = { type: 1 }
      getSale(data)
        .then(res => {
          let datas = res.data
          this.saleData = datas.slice(0, 20)
        })
        .catch(err => {
          console.log(err)
        })
      // this.$http.post('/getSale ', data).then(res => {
      //   if (res.data.code) {
      //     let data = res.data.data
      //     this.saleData = data.slice(0, 20)
      //   }
      // })
    },
    // 查看更多
    headerMore() {
      let status = this.$store.getters.urlStatus
      this.$router.push({
        name: status ? 'business_yl' : 'business',
        query: { routerPath: 'hzhb' }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.cooperate {
  background-image: url('../../assets/image/back.png');
  height: 630px;
  background-size: 100% 100%;
  // padding-bottom: 36%;
  // overflow: hidden;
  // background-position: center center;
  background-repeat: no-repeat;
  padding-top: 30px;
  h2 {
    text-align: center;
    color: #fff;
    font-size: 30px;
    font-weight: 400;
  }
  .content {
    background: #fff;
    margin: 30px auto;
    // margin: 30px auto 0 auto;
    width: 1200px;
  }
  .content_first {
    background: url('../../assets/image/icons.png') no-repeat center top;
    background-size: contain;
    // width: 1200px;
    height: 350px;
  }
  .content-icons {
    .icons {
      display: flex;
      align-content: center;
      justify-content: space-around;
      margin: 10px 30px 0 30px;
      img {
        display: block;
        margin: 0px 8px;
      }
    }
    .icons-one {
      img {
        display: block;
        margin: 30px 8px;
      }
    }
    .icons-thr {
      display: flex;
      align-content: center;
      margin: 20px 30px 0 50px;
      img {
        // flex-basis: 15%;
        display: block;
        margin: 30px 14px;
      }
    }
  }
  .content_sec {
    height: 310px;
    margin-bottom: 40px;
    text-align: center;
    img {
      width: 400px;
      margin-top: 40px;
    }
  }
  .content_thr {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 40px;

    div {
      margin: 15px 15px 10px 15px;
      flex-basis: 22%;
      // width: 400px;
      height: 40px;
      line-height: 40px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(186, 186, 186, 1);
      font-size: 14px;
      font-weight: 400;
      color: rgba(38, 38, 38, 1);
      text-align: center;
    }
  }
  .bottom {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    height: 55px;
    border: 2px solid rgba(255, 255, 255, 0.25);
    border-radius: 4px;
    margin: 40px auto 0px auto;
    // padding-bottom: 25%;

    color: #fff;
    p {
      font-weight: 400;
      line-height: 55px;
      cursor: pointer;
    }
    i {
      font-size: 40px;
      line-height: 55px;
      opacity: 0.25;
    }
  }
  .el-tabs--border-card {
    background: none !important;
    border: none;
    box-shadow: none;
  }
  .el-tabs--border-card > .el-tabs__header {
    background-color: none;
    border: none;
  }
  /deep/.el-tabs {
    .el-tabs__header {
      width: 380px;
      margin: 20px auto;
    }
    .el-tabs__nav-prev {
      display: none;
    }
    .el-tabs__nav-next {
      display: none;
    }
    .m-circle-dot {
      margin-left: 20px;
    }
    .el-tabs__active-bar {
      background: #fff;
      // width: 80px !important;
    }

    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__item.is-active {
      color: #fff;
    }

    .el-tabs__item {
      color: #fff;
      font-size: 18px;
    }
    .el-tabs__item:hover {
      color: #fff;
    }
  }
}
</style>
